import { Injectable, NgZone } from "@angular/core";
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthenticationService } from "./authenticationService";
import { OfflineService } from "./offlineService";
import { StringConstants } from "../_store/stringConstants";
import { DialogServiceService } from "../_app-core/dialogs/dialog-service.service";

@Injectable({
    providedIn: "root",
})
export class CustomHttpInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private offlineService: OfflineService,
        private dialogsService: DialogServiceService
    ) {}

    private skipErrorThrows = ["/app/offer", "dashboard/landingPageSummary","/create?tenantDB=ims", "/get/", "/JSW/api/ticket/upload"];

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const url = request.url;
        const reqBody = request.body;
        const isPOST = request.method === "POST";
        if (isPOST) {
            
            
            // if (
            //     this.authenticationService.currentUserData &&
            //     this.authenticationService.currentUserData.session
            // ) {
            if(this.authenticationService.currentUserData && this.authenticationService.currentUserData.session) {
                reqBody.session = (
                    this.authenticationService.currentUserData || {}
                ).session;      
            }              
                        
            if (url.includes('/JSW/api/ticket/') || url.includes('/saveVendorQuery')|| url.includes('/uploadSupDoc') ) {
                request = request.clone({
                    url,
                    body: reqBody
                });
            } else if (url.includes('/PayEXDCAPI') || !url.includes('login')) {
                const sessionId = localStorage.getItem("sessionId");
                if (sessionId) {
                    request = request.clone({
                        url,
                        body: reqBody,
                        headers: request.headers.set('token', sessionId)
                    });
                } else {
                    request = request.clone({
                        url,
                        body: reqBody
                    });
                }
            } else {
                request = request.clone({
                    url,
                    body: reqBody
                });
            }

            
            // }
            const offlineRes = this.offlineService.getDummyResponse(request);
            if (offlineRes) {
                return of(
                    new HttpResponse({ status: 200, body: offlineRes as any })
                );
            }
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.code === "401") {
                        this.authenticationService.logout();
                    }
                    // this.errorDialogService.openDialog(event);
                    if (event.body) {
                        const res: any = event.body;
                        const isSuccess =
                            (res.status || res.success || res.utr) &&
                            !res.error &&
                            res.status !== "error";
                        const skipThrow =
                            this.skipErrorThrows.find((urlToSkip) => {
                                return event.url.indexOf(urlToSkip) !== -1;
                            }) !== undefined;
                        if (!skipThrow && !isSuccess) {
                            throw new Error(
                                this.mapTimeoutMessage(
                                    event.url,
                                    res.error ||
                                        res.msg ||
                                        res.message ||
                                        StringConstants.MESSAGES
                                            .INVALID_SERVICE_RESPONSE
                                )
                            );
                        }
                    }
                    const urlIsForView =
                        event.url &&
                        (event.url.indexOf("/error") === -1 ||
                            event.url.indexOf("invoice_data") === -1);
                    if (!event.body && !urlIsForView) {
                        throw new Error(
                            StringConstants.MESSAGES.SERVER_GENERAL_ERROR
                        );
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                
                const errorCode = error && error.status;
                if (!navigator.onLine) {
                    this.dialogsService.showServerError("nointernet");
                } else {
                    let data = {
                        message:
                            error && error.error && error.error.reason
                                ? error.error.reason
                                : error.message
                                ? error.message
                                : error,
                        status: error.status,
                        header: "Error",
                    };
                    if (
                        errorCode === 404 ||
                        data.message.indexOf("not found") !== -1
                    ) {
                        this.dialogsService.showErrorModal(
                            StringConstants.MESSAGES.DOC_NOT_FOUND
                        );
                    } else if (
                        data.message.indexOf("Oops! There seems") !== -1 ||
                        data.message.indexOf("Unknown") !== -1
                    ) {
                        this.dialogsService.showServerError("servererror");
                    } else {
                        this.dialogsService.showErrorModal(data.message);
                    }
                }
                return throwError(error);
            })
        );
    }

    /** Per-URL replacement of the Vert.x reply-timeout text; each rule is gated by its own uiConfig flag (default OFF). */
    private readonly TIMEOUT_MESSAGE_RULES: ReadonlyArray<{
        urlPart: string;
        flag: string;
        message: string;
    }> = [
        {
            urlPart: "apSaas/extractEInvoiceData",
            flag: "extractTimeoutAsQrError",
            message:
                "QR code unreadable. Not represented or low dpi... Make sure this is a valid E-invoice!",
        },
        {
            urlPart: "apSaas/verifyDigitallySignedInvoice",
            flag: "verifySignatureTimeoutAsInvalidError",
            message:
                "Invoice is not Digitally Signed/Digital Signature is invalid!",
        },
    ];

    /** uiConfig.<flag> from sessionStorage "currentUser" — only a literal true turns it on. */
    private isUiConfigFlagEnabled(flag: string): boolean {
        try {
            const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
            return currentUser?.uiConfig?.[flag] === true;
        } catch (e) {
            return false;
        }
    }

    /** Swap the Vert.x reply-timeout text for the rule's message when the URL matches and its flag is on. */
    private mapTimeoutMessage(url: string, message: any): any {
        if (
            typeof url !== "string" ||
            typeof message !== "string" ||
            !(
                message.includes("(TIMEOUT,") ||
                message.includes("Timed out after waiting")
            )
        ) {
            return message;
        }
        const rule = this.TIMEOUT_MESSAGE_RULES.find((r) =>
            url.includes(r.urlPart)
        );
        return rule && this.isUiConfigFlagEnabled(rule.flag)
            ? rule.message
            : message;
    }
}
